module.exports = __webpack_public_path__ + "img/freemoney.8ee1b044.png";